/* import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.defaults.font.family = "Nunito";
ChartJS.defaults.font.size = 10;

const DoughnutChartDB = ({ transactionType }) => {
  console.log(transactionType);

  const data = {
    labels: ["Paid", "On loan"],
    datasets: [
      {
        label: "Amount",
        data: transactionType,
        backgroundColor: ["#30A7EC", "rgb(204, 42, 99)" ],
     
        borderWidth: 1,
        cutout: 48,
        borderRadius: 10,
        hoverBackgroundColor: ["rgb(85, 184, 250)", "rgb(243, 78, 136)"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 8,
        },
      },
      title: {
        display: false,
        text: "confiq.title",
      },
    },
  };
  return (
    <div className='DoughnutChart'>
      <Doughnut data={data} options={options} />
      <div className='don947563'>
      
      </div>
    </div>
  );
};

export default DoughnutChartDB;
 */

import { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

/*
  DoughnutChartDB
  ───────────────
  Props:
    transactionType — [paidAmount, loanAmount]  e.g. [982961, 58300]
    currency        — string  e.g. "₦"
*/
export default function DoughnutChartDB({ transactionType = [0, 0], currency = "₦" }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  const [paid = 0, loan = 0] = transactionType;

  const fmtVal = (v) => {
    if (v >= 1e6) return currency + (v / 1e6).toFixed(1) + "M";
    if (v >= 1e3) return currency + (v / 1e3).toFixed(0) + "K";
    return currency + v.toLocaleString();
  };

  useEffect(() => {
    if (!canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    chartRef.current = new Chart(canvasRef.current, {
      type: "doughnut",
      data: {
        labels: ["Paid", "On loan"],
        datasets: [
          {
            data: [paid, loan],
            backgroundColor: ["#1e3a5f", "#d85a30"],
            hoverBackgroundColor: ["#2a5080", "#e06840"],
            borderWidth: 0,
            hoverOffset: 6,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "40%" /* thick ring */,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => ` ${ctx.label}: ${fmtVal(ctx.raw)}`,
            },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [paid, loan, currency]);

  return (
    <div style={{ position: "relative", width: "100%", height: 260 }}>
      <canvas ref={canvasRef} role='img' aria-label={`Donut chart: ${fmtVal(paid)} paid, ${fmtVal(loan)} on loan`} />
    </div>
  );
}
